import styled from "styled-components";





export const Signup = styled.div`
background-color: rgba(23, 24, 25, 1);
`

export const SignupBody = styled.div`
display: flex;
justify-content: space-around;
align-items: center;
min-height: 6.25rem;
@media (max-width:47.94rem) {
  flex-direction: column;
}
`
export const SignupForm = styled.form`

@media (max-width:47.94rem) {
   padding: 5px 0px 15px;
}
@media (max-width:29rem) {
   display:block;
}
`



export const SignupTitle = styled.div`
font-size: 1.4rem;
font-weight: 700;
color: rgb(255,255,255);
@media (max-width:47.94rem) {
   padding: 10px 0px;
}
`

export const SignupInput = styled.input`
width: 15.6rem;
height: 2.5rem;
padding: 0rem 1rem;
font-size: 1.3rem;
vertical-align: top;
@media (max-width:29rem) {
   width: 100%;
   margin-bottom: 10px;
}
`

